const events = {
  AUTO_SAVE_WORDS: 'autoSaveWords',
  DEVICE_TYPE_CHECKED: 'deviceTypeChecked',
  CANCEL_DEVICE_TYPE_CHECKED: 'cancelDeviceTypeChecked',
  FLOOR_CHECKED: 'floorChecked',
  CANCEL_FLOOR_CHECKED: 'cancelFloorChecked',
  DEVICE_CHECKED: 'deviceChecked',
  DEVICE_DOUBLE_CLICKED: 'deviceDoubleClicked',
  CANCEL_DEVICE_CHECKED: 'cancelDeviceChecked',
  REFRESH_DEVICE_LIST: 'refreshDeviceList',
  REMOVE_DEVICE: 'removeDevice',
  UPDATE_FLOORINFO: 'updateFloorInfo',
};

export { events };
